// Enum-like constant sets shared between API, web, worker, and DB code.
//
// Ported incrementally from the original podcastwiz constants file —
// each phase adds the sets its routes touch, keeping unused constants out
// of the shared bundle. Schema files (podcast/episode/etc.) reference
// these via `as const` arrays so Zod and TypeScript get a tight union.
export const TEAM_ROLES = ['owner', 'admin', 'editor', 'viewer'];
export const PODCAST_TYPES = ['episodic', 'serial'];
export const EPISODE_STATUSES = [
    'draft',
    'editing',
    'ready',
    'scheduled',
    'published',
    'archived',
];
export const EPISODE_TYPES = ['full', 'trailer', 'bonus'];
export const TRACK_TYPES = ['audio', 'video'];
/** Default audio sample rate in Hz. Matches the DB column default. */
export const DEFAULT_SAMPLE_RATE = 48_000;
//# sourceMappingURL=constants.js.map